import {PromoDto, PromoItemsDto, SaleTypeDto, SellingUnitDto} from "../dtos";

export const getPromoSaleTypeCaptionForType70UsingSellingUnits = (
    saleType: SaleTypeDto,
    currencySymbol: string,
    sellingUnit?: SellingUnitDto,
    promotion?: PromoDto,
    isHebrew?: boolean
): string => {
    let caption = '';
    if(sellingUnit){
        switch (sellingUnit.id){
            default:
                if(sellingUnit.languageDisplayCaption){
                    caption = sellingUnit?.languageDisplayCaption.replace(/<CurrencySymbol>/g, currencySymbol)
                        .replace(
                            /<Price>/g,
                            promotion!.flrSalePrice
                                ? promotion!.flrSalePrice.toFixed(2).toString()
                                : "promotion!.flrSalePrice = null"
                        )
                        .replace(
                            // /<Qty>/g,
                            promotion!.flrBuyQty === 1 && isHebrew ? /<Qty> /g : /<Qty>/g,
                            promotion!.flrBuyQty && promotion!.flrBuyQty !== 1
                                ? promotion!.flrBuyQty.toString()
                                : ""
                        )
                        .replace(
                            /<SellingUnitCaption>/g,
                            sellingUnit?.languageCaption
                                ? sellingUnit?.languageCaption.toString()
                                : "sellingUnit?.languageCaption = null"
                        )
                        .replace(
                            /<SellingUnitAbbrv>/g,
                            sellingUnit?.languageAbbrv
                                ? sellingUnit?.languageAbbrv.toString()
                                : "sellingUnit?.languageAbbrv = null"
                        )
                }
                break;
        }
    } else {
        caption = `sellingUnit: undefined`
    }
    return caption
}

export const getPromoSaleTypeCaptions = (
    saleType: SaleTypeDto,
    currencySymbol: string,
    sellingUnit?: SellingUnitDto,
    promotion?: PromoDto,
) => {
    let caption = "";
    try {
        const isHebrew = saleType.lacCode === "he-IL";
        // const unit = isHebrew ? "יח'" : "unit";
        switch (promotion?.flrSatCode) {
            case 1:
                caption = saleType.displayCaption!;
                break;
            case 2:
                caption = saleType
                    .displayCaption!.replace(/<currencySymbol>/g, currencySymbol)
                    .replace(
                        /<SalePrice>/g,
                        promotion?.flrSalePrice
                            ? promotion?.flrSalePrice.toFixed(2).toString()
                            : "promoSalePrice = null"
                    );
                break;
            case 10:
            case 11:
                caption = saleType
                    .displayCaption!.replace(/<currencySymbol>/g, currencySymbol)
                    .replace(
                        /<SalePrice>/g,
                        promotion?.flrSalePrice
                            ? promotion?.flrSalePrice.toFixed(2).toString()
                            : "promoSalePrice = null"
                    )
                    .replace(/<SellingUnit>/g, sellingUnit?.languageCaption ? ` ${sellingUnit.languageCaption}` : ` sellingUnit: undefined`);
                break;
            case 12:
                const itemsPricesArray: number[] | undefined = promotion?.flyerPromoItems?.map((item: PromoItemsDto) => {
                    return item.fpiRegularPrice;
                });
                let minRegPrice = 0;
                let maxRegPrice = 0;
                if(itemsPricesArray){
                    maxRegPrice = Math.max(...itemsPricesArray);
                    minRegPrice = Math.min(...itemsPricesArray);
                }
                let regularPricesRange: string = ``;
                if(minRegPrice === maxRegPrice){
                    regularPricesRange = `${maxRegPrice % 1 !== 0 ? maxRegPrice.toFixed(2).toString() : maxRegPrice.toString()}`
                } else {
                    const minRegPriceConv = minRegPrice % 1 !== 0 ? minRegPrice.toFixed(2).toString() : minRegPrice.toString();
                    const maxRegPriceConv = maxRegPrice % 1 !== 0 ? maxRegPrice.toFixed(2).toString() : maxRegPrice.toString();
                    regularPricesRange = `${minRegPriceConv}-${currencySymbol}${maxRegPriceConv}`
                }
                caption = saleType
                    .displayCaption!.replace(/<currencySymbol>/g, currencySymbol)
                    .replace(
                        /<SalePrice>/g,
                        promotion?.flrSalePrice
                            ? (promotion?.flrSalePrice % 1 !== 0 ? promotion?.flrSalePrice.toFixed(2).toString() : promotion?.flrSalePrice.toString())
                            : "promoSalePrice = null"
                    )
                    .replace(
                        /<RegPrice>/g,
                        Boolean(regularPricesRange)
                            ? regularPricesRange
                            : "items missing prices"
                    );
                break;
            case 13:
                caption = saleType
                    .displayCaption!.replace(/<currencySymbol>/g, currencySymbol)
                    .replace(
                        /<SalePrice>/g,
                        promotion?.flrGetAmountOff
                            ? (promotion?.flrGetAmountOff % 1 !== 0 ? promotion?.flrGetAmountOff.toFixed(2).toString() : promotion?.flrGetAmountOff.toString())
                            : "promoSalePrice = null"
                    )
                    .replace(
                        /<BuyQty>/g,
                        promotion?.flrBuyQty
                            ? promotion?.flrBuyQty.toString()
                            : "flrBuyQty = null"
                    )
                if (!promotion?.flrBuyQty || promotion?.flrBuyQty === 0 || (promotion?.flrBuyQty && promotion?.flrBuyQty >= 100)) {
                    caption = caption.replace(/ *\([^)]*\) */g, "");
                }
                break;
            case 20:
            case 21:
                caption = saleType
                    .displayCaption!.replace(/<currencySymbol>/g, currencySymbol)
                    .replace(
                        /<SalePrice>/g,
                        promotion?.flrSalePrice
                            ? promotion?.flrSalePrice.toFixed(2).toString()
                            : "promoSalePrice = null"
                    )
                    .replace(
                        /<BuyQty>/g,
                        promotion?.flrBuyQty
                            ? promotion?.flrBuyQty.toString()
                            : "promoBuyQty = null"
                    );
                break;
            case 30:
                caption = saleType
                    .displayCaption! // .replace(/{CurrencySymbol}/g, currencySymbol)
                    // .replace(/{RegPrice}/g, promo!.flrRegularPrice ? promo!.flrRegularPrice.toFixed(2).toString() : 'promoRegularPrice = null')
                    .replace(
                        /<GetPctOff>/g,
                        promotion?.flrGetPctOff
                            ? promotion?.flrGetPctOff.toString()
                            : "promoGetPctOff = null"
                    );
                break;
            case 40:
                caption = saleType
                    .displayCaption!.replace(/<currencySymbol>/g, currencySymbol)
                    .replace(
                        /<SalePrice>/g,
                        promotion!.flrSalePrice
                            ? promotion!.flrSalePrice.toFixed(2).toString()
                            : "promoSalePrice = null"
                    );
                break;
            case 41:
                caption = saleType.displayCaption!.replace(
                    /<PctOff>/g,
                    promotion?.flrGetPctOff
                        ? promotion?.flrGetPctOff.toString()
                        : "promoGetPctOff = null"
                );
                break;
            case 44:
                caption = saleType.displayCaption!.replace(
                    /<PctAt>/g,
                    promotion?.flrPctAt
                        ? promotion?.flrPctAt.toString()
                        : "promoPctAt = null"
                );
                break;
            case 50:
            case 51:
                caption = saleType.displayCaption!.replace(
                    /<BuyQty>/g,
                    promotion?.flrBuyQty
                        ? promotion?.flrBuyQty.toString()
                        : "promoBuyQty = null"
                );
                break;
            case 62:
            case 63:
                caption = saleType
                    .displayCaption!.replace(/<currencySymbol>/g, currencySymbol)
                    .replace(
                        /<BuyAmount>/g,
                        promotion?.flrBuyAmount
                            ? promotion?.flrBuyAmount.toFixed(2).toString()
                            : "promoBuyAmount = null"
                    )
                    .replace(
                        /<GetAmount>/g,
                        promotion?.flrGetAmountOff
                            ? promotion?.flrGetAmountOff.toString()
                            : "promoGetAmountOff = null"
                    );
                break;
            case 70:
            case 71:
            case 72:
                caption = getPromoSaleTypeCaptionForType70UsingSellingUnits(saleType, currencySymbol, sellingUnit, promotion, isHebrew)
                // caption = saleType
                //     .displayCaption!.replace(/<currencySymbol>/g, currencySymbol)
                //     .replace(
                //         /<SalePrice>/g,
                //         promotion!.flrSalePrice
                //             ? promotion!.flrSalePrice.toFixed(2).toString()
                //             : "promoSalePrice = null"
                //     )
                //     .replace(
                //         /<BuyQty>/g,
                //         promotion!.flrBuyQty
                //             ? promotion!.flrBuyQty.toString()
                //             : "promotion!.flrBuyQty = null"
                //     )
                //     .replace(
                //         /<UomCaption>/g,
                //         sellingUnit.languageCaption
                //             ? sellingUnit.languageCaption.toString()
                //             : "sellingUnit.languageCaption = null"
                //     );
                break;
            case 80:
                const benefitItem = promotion?.flyerPromoItems?.find((promoItem: PromoItemsDto) => {
                    if(promoItem.fpiIsBenefit){
                        return promoItem;
                    }
                })
                caption = saleType
                    .displayCaption!.replace(/<currencySymbol>/g, currencySymbol)
                    .replace(
                        /<Requisite>/g,
                        promotion!.flrBuyQty
                            ? promotion!.flrBuyQty.toString()
                            : "promotion!.flrBuyQty = null"
                    )
                    .replace(
                        /<promo Caption>/g,
                        promotion!.flrCaption
                            ? promotion!.flrCaption.toString()
                            : "promotion!.flrDisplayCaption1 = null"
                    )
                    .replace(
                        /<Benefit ItemCode caption>/g,
                        benefitItem
                            ? `${benefitItem.fpiCode} ${benefitItem.fpiDisplayCaption1}`
                            : "no gift items in promo"
                    );
                break;
                // .replace(/<currencySymbol>/g, currencySymbol)
                // .replace(/<SalePrice>/g, promotion!.flrSalePrice ? promotion!.flrSalePrice.toFixed(2).toString() : 'promoSalePrice = null')
            case 81:
                caption = saleType
                    .displayCaption!.replace(
                    /<BuyQty>/g,
                    promotion?.flrBuyQty
                        ? promotion?.flrBuyQty.toString()
                        : "promoBuyQty = null"
                )
                    .replace(/<currencySymbol>/g, currencySymbol)
                    .replace(
                        /<<GetItemCode>Caption>/g,
                        promotion!.flrCaption
                            ? `${promotion!.flrCaption} HARDCODE CODE`
                            : "promoSalePrice = null"
                    );
                break;
            default:
                caption = saleType.displayCaption!;
                break;
        }

        return caption;
    } catch (err) {
        console.log("saleTypesArrayIsEmpty");
        return caption;
    }
};

export const convertPromoPropertiesToGenericParams = (
    promotion: PromoDto,
    selectedSaleType: SaleTypeDto
): {
    benefit: number | null | undefined;
    requisite: number | null | undefined;
    saleTypeCode: number | null | undefined;
} => {
    let genericParams: any;
    switch (selectedSaleType.satCaption) {
        case "BogoAtPercentAtCheapest":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrPctAt,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BogoAtPercentOff":
            genericParams = {
                requisite: 1,
                benefit: promotion.flrGetPctOff,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BogoAtPrice":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "Buy100GRAtPrice":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "Coupon":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrGetAmountOff,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyAmountGetAmountOffOnce":
            genericParams = {
                requisite: promotion.flrBuyAmount,
                benefit: promotion.flrGetAmountOff,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyAmountGetAmountOffRepeat":
            genericParams = {
                requisite: promotion.flrBuyAmount,
                benefit: promotion.flrGetAmountOff,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyAnyOfAtPrice":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyAtRegularAt":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyItemXGetItemYFree":
            const benefitItem = promotion?.flyerPromoItems?.find((promoItem: PromoItemsDto) => {
                if(promoItem.fpiIsBenefit){
                    return promoItem;
                }
            })

            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: benefitItem ? benefitItem.fpiCode : '',
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyKGAtPrice":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyLBAtPrice":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyOneAtPrice":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyQtyAtPrice":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyQtyGetOneFree":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrGetQty,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyQtyGetOneFreeCheapest":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrGetQty,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "NewItems":
            genericParams = {
                requisite: promotion.flrSalePrice,
                benefit: null,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "PercentOff":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrGetPctOff,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "StartingFromPrice":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        case "BuyUomAtPrice":
            genericParams = {
                requisite: promotion.flrBuyQty,
                benefit: promotion.flrSalePrice,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
        default:
            genericParams = {
                benefit: promotion.flrSalePrice,
                requisite: promotion.flrBuyQty,
                saleTypeCode: promotion.flrSatCode,
            };
            break;
    }

    return genericParams;
};

export const convertGenericPromoParamsToProperties = (
    promotion: PromoDto,
    selectedSaleType: SaleTypeDto
) => {
    let promo = {...promotion};
    switch (selectedSaleType.satCaption) {
        case "BogoAtPercentAtCheapest":
            promo.flrBuyQty = 1;
            promo.flrPctAt = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BogoAtPercentOff":
            promo.flrBuyQty = 1;
            promo.flrGetPctOff = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BogoAtPrice":
            promo.flrBuyQty = 1;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "Coupon":
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrGetAmountOff = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "Buy100GRAtPrice":
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyAmountGetAmountOffOnce":
            promo.flrBuyAmount = selectedSaleType.requisite;
            promo.flrGetAmountOff = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyAmountGetAmountOffRepeat":
            promo.flrBuyAmount = selectedSaleType.requisite;
            promo.flrGetAmountOff = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyAnyOfAtPrice":
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyAtRegularAt":
            promo.flrBuyQty = 1;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyItemXGetItemYFree":
            promo?.flyerPromoItems?.forEach((promoItem: PromoItemsDto) => {
                promoItem.fpiIsBenefit = Number(promoItem.fpiCode) === Number(selectedSaleType.benefit)
            })
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyKGAtPrice":
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyLBAtPrice":
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyOneAtPrice":
            promo.flrBuyQty = 1;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyQtyAtPrice":
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyQtyGetOneFree":
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrGetQty = 1;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyQtyGetOneFreeCheapest":
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrGetQty = 1;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "NewItems":
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "PercentOff":
            promo.flrBuyQty = 1;
            promo.flrGetPctOff = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "BuyUomAtPrice":
            promo.flrBuyQty = selectedSaleType.requisite;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "StartingFromPrice":
            promo.flrBuyQty = 1;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        case "SalePrice":
            promo.flrBuyQty = 1;
            promo.flrSalePrice = selectedSaleType.benefit;
            promo.flrSatCode = selectedSaleType.satCode;
            break;
        default:
            break;
    }
    return promo;
};
